import { useRouteError, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '../components/ui/button'
import { pagePanel } from './layout/page-styles'
import { cn } from '../lib/utils'

export function ErrorPage() {
  const { t } = useTranslation()
  const error = useRouteError() as any
  console.error('Route error:', error)

  const is404 = error?.status === 404

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-page p-4">
      <div className={cn(pagePanel, 'w-full max-w-md p-8')}>
        <div className="text-center">
          <div className="w-14 h-14 rounded-full bg-error-50 flex items-center justify-center mx-auto mb-4">
            <svg className="w-7 h-7 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <h1 className="text-lg font-semibold text-neutral-900 mb-2">
            {is404 ? t('errorPage.notFoundTitle') : t('errorPage.unexpectedTitle')}
          </h1>
          <p className="text-sm text-neutral-500 mb-6">
            {is404 ? t('errorPage.notFoundMessage') : t('errorPage.unexpectedMessage')}
          </p>

          {process.env.NODE_ENV === 'development' && error && !is404 && (
            <details className="mb-6 text-left">
              <summary className="cursor-pointer text-xs font-medium text-neutral-500 mb-2">
                {t('common.devErrorDetails')}
              </summary>
              <div className="bg-neutral-50 border border-neutral-100 p-3 rounded-lg text-xs font-mono text-neutral-600 overflow-auto max-h-32">
                <p><strong>{t('common.devStatus')}</strong> {error.status || 'Unknown'}</p>
                <p><strong>{t('common.devMessage')}</strong> {error.message || error.statusText || 'Unknown'}</p>
              </div>
            </details>
          )}

          <div className="flex gap-3 justify-center">
            <Link to="/">
              <Button variant="primary" size="md">{t('common.backToHome')}</Button>
            </Link>
            <Button onClick={() => window.history.back()} variant="secondary" size="md">
              {t('common.back')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
